import { render, staticRenderFns } from "./snackBar.vue?vue&type=template&id=064fca0a"
import script from "./snackBar.vue?vue&type=script&lang=js"
export * from "./snackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports